import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PagesRoutingModule } from './pages-routing.module';
import { PreAuthModule } from './pre-auth/preAuth.module';
import { MainComponent } from './main/main.component';
import { MainModule } from './main/main.module';
import { MatTableModule } from '@angular/material/table';

@NgModule({
  declarations: [MainComponent],

  imports: [
    CommonModule,
    PagesRoutingModule,
    PreAuthModule,
    MainModule,
    BrowserAnimationsModule,
    MatTableModule,
  ],
})
export class PagesModule {}
